import type { LiliDropdownItem } from './LiliDropdown';
import { ReactComponent as CheckMark } from '../../../assets/shared/ic-shared-checkmark.svg';
import { useFontClass } from '../../tokens';

interface LiliDropdownItemProps {
  item: LiliDropdownItem;
  isSelected: boolean;
  optionValue?: string;
}

export const LiliDropDownItemTemplate = ({
  item,
  isSelected,
  optionValue,
}: LiliDropdownItemProps) => {
  const { fontClass } = useFontClass();

  return (
    <div
      className='px-[8px] py-[4px] !h-[42px] items-center border-b-[1px] border-b-outline-primary-bw-03 w-full cursor-pointer'
      key={item.value}
      id={`dropdown-item-${getItemValue(item.value, optionValue)}`}>
      <div
        className={`flex flex-row  justify-between w-full h-full items-center hover:bg-surface-primary-bw-02 rounded-md px-[12px] py-[6px] ${
          isSelected ? 'bg-surface-brand-action-00' : ''
        } `}>
        <div
          className={`${fontClass} text-[14px] ${isSelected ? 'text-text-brand-primary' : 'text-text-main-primary'}`}>
          {item.title}
        </div>
        {isSelected && <CheckMark className='text-text-brand-primary' />}
      </div>
    </div>
  );
};

const getItemValue = <T extends LiliDropdownItem['value']>(value: T, optionValue?: keyof T) => {
  if (typeof value === 'object' && optionValue) {
    return value?.[optionValue];
  }
  return value;
};
